.modalBody {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
}

.informationRow {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacingLg);

  &.twoColumns {
    grid-template-columns: repeat(2, 1fr);
  }
}

.list {
  list-style: disc;
  padding-left: var(--spacingLg);
  margin-bottom: 0;

  li:not(:last-child) {
    margin-bottom: var(--spacingLg);
  }
}
